import React, {useMemo} from 'react';
import UploadIcon from "../assets/images/upload-icon";

const FormInput = (props) => {
    const { label, type, value, onChange, error, helper, children, className, extra, ...rest } = props;
    const isFileInput = useMemo(() => type === 'file', [type]);

    return (
        <div>
            <div className="input-wrapper">
                <label>{label}</label>
                {children ??
                <>
                {isFileInput ?
                    <div className="upload-input-wrapper">
                        <label className="uploadFile">
                            <span className="filename">{value?.name ?? ''}</span>
                            <input type="file"
                                   onChange={(e) => onChange(e.target.files[0])}
                                   {...rest}
                            />
                        </label>
                        <UploadIcon fill={'#9d9d9d'} className="upload-icon"/>
                    </div>
                    :
                    <input className={`form-input-style ${className}`}
                           type={type}
                           value={value}
                           onChange={(e) => onChange(e.target.value)}
                           {...rest}
                    />}
                </>}
                <span className="small">{helper}</span>
                <div style={{color: 'red', fontSize: '14px'}}>{error}</div>
            </div>
        </div>
    );
};

export default FormInput;